import React from 'react';
import Icon from './Icon';

const ChevronUpIcon = (props) => (
    <Icon {...props}>
        <path d="M6 15L12 9L18 15" strokeLinecap="round" strokeLinejoin="round" />
    </Icon>
);

export default ChevronUpIcon;